import {reactive} from 'vue'

export default {
    install: (app, options) => {

        const open = () => {
            document.documentElement.classList.add('modal-opened')
        }
        const close = () => {
            document.documentElement.classList.remove('modal-opened')
        }
        app.config.globalProperties.$modal = reactive({
                open() {
                    open();
                },
                close() {
                    close();
                }
            }
        );

        options.router.beforeEach(() => {
            close();
        })
    }
}
